import { plainToInstance } from 'class-transformer'

import { Entity } from '@core/entities/entity'
import { IBriefingSessionParticipant } from './IBriefingSessionParticipant'

export class BriefingSessionParticipant extends Entity<IBriefingSessionParticipant> {
  sessionParticipantId: string
  participantId?: number
  userId?: number

  firstName: string
  lastName: string
  company: string
  briefOnRoleId: number
  signatureKey?: string // Present if the participant was briefed during current briefing session

  public static new(payload: unknown): BriefingSessionParticipant {
    const entity = plainToInstance(BriefingSessionParticipant, payload)
    return entity
  }
}
